import React from 'react'
import { connect } from 'react-redux'

import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

import AssetSettings from '@components/tools/asset-settings'

import { isOffline } from '@utilities/offline-handler-util'

import pkg from '../../../package.json'
import Disconnect from './disconnect'
import Refresh from './refresh'

interface ToolsProps {
  className?: string
  projectIdentity: ProjectIdentity
}

function Tools({ className = '', projectIdentity }: ToolsProps) {
  return (
    <div className={`p-5 ${className}`}>
      <div className="mb-4 flex w-full items-center justify-center py-2 text-title font-medium text-neutralColour">
        Tools
      </div>
      <div className="no-scrollbar w-full overflow-auto">
        <div className="grid grid-rows-2 gap-4">
          <div>
            <AssetSettings />
          </div>
          {projectIdentity.showClearCacheOption && !isOffline() && (
            <div>
              <Refresh />
            </div>
          )}
          {projectIdentity.disconnect && (
            <div>
              <Disconnect projectIdentity={projectIdentity} />
            </div>
          )}
        </div>
      </div>

      <div className="absolute bottom-5 right-5">
        <p className="text-sm text-neutralColour">
          Remote version: {pkg?.version || '-'}
        </p>
      </div>
    </div>
  )
}

const mapStateToProps = ({ projectIdentity }: RootStateTypeExtra) => ({
  projectIdentity,
})

export default connect(mapStateToProps)(Tools)
